import { authHeader, isTokenExpired } from "../helpers";

export const modelsManagementService = {
  getAllConfigModels,
  createModel,
  updateModel,
  deleteModel,
  getModelManagementUrlFromS3,
  getModelManagementPreviewUrlFromS3,
};

function getAllConfigModels(isAdmin) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(true),
  };

  const url = isAdmin
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/model3d`
    : `${process.env.REACT_APP_GATEWAY_URL}/model3d`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function createModel(model) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(model),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/model3d`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateModel(model) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify(model),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/model3d`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteModel(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/model3d/${id}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getModelManagementUrlFromS3(files, isUsdz) {
  const formData = new FormData();
  for (const file of files) {
    formData.append(
      isUsdz ? "usdz" : "model",
      file,
      file.name.replaceAll(" ", "")
    );
  }

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: formData,
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}/admin/model3d/${
    isUsdz ? "usdz" : "model"
  }`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getModelManagementPreviewUrlFromS3(files, currentUrl, isAdmin, expId) {
  const blobName = currentUrl
    .split("/")
    [currentUrl.split("/").length - 1].split(".")[0];
  const formData = new FormData();
  if (files instanceof Blob) {
    formData.append("preview", files, blobName);
  } else {
    for (const file of files) {
      formData.append("preview", file, file.name);
    }
  }

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: formData,
  };

  const url = isAdmin
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/model3d/preview`
    : `${process.env.REACT_APP_GATEWAY_URL}/dm/${expId}/model3d/preview`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
